import { Box, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // Import close icon
import React, { useState } from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";

export const Phone: React.FC<any> = React.memo((props) => {
  const [phoneNumber, setPhoneNumber] = useState<string>("");
const navigate = useNavigate()
  // Function to handle keypad button clicks
  const handleButtonClick = (key: string) => {
    if (key === "←") {
      // Remove the last digit (backspace)
      setPhoneNumber(phoneNumber.slice(0, -1));
    } else {
      // Append the clicked digit or symbol
      setPhoneNumber((prev) => prev + key);
    }
  };

  // Handle direct input change from the TextField
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Set the phone number directly from the input field
    setPhoneNumber(event.target.value);
  };
const handleClick = (path:string)=>{
  navigate(path)
}
  return (
    <Grid>
 <Grid item sx={{display:"flex", justifyContent:"space-between", alignItems: 'center', padding: '16px' }}>
        <Typography variant="h6" color={"green"}>Guest Search</Typography>
        <IconButton>
          <WSIcons.CloseIcon
            sx={{ backgroundColor: "red", color: "white" }}
            onClick={() => handleClick("/")}
          />
        </IconButton>
      </Grid>
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ padding: 4, height: "calc(100vh - 150px)" }}
    >
      <Grid item xs={12} md={6}>
       

        {/* Phone Input */}
        <Grid mb={4} textAlign="center">
          <TextField
            label="Enter Phone No"
            variant="outlined"
            value={phoneNumber} // Controlled input value
            onChange={handleInputChange} // Handle manual input changes
            fullWidth
            sx={{ maxWidth: "400px", margin: "0 auto" }}
          />
        </Grid>

        {/* Keypad */}
        <Grid container spacing={2} sx={{ maxWidth: "400px", margin: "0 auto" }}>
          {["1", "2", "3", "4", "5", "6", "7", "8", "9", "←", "0", "+"].map((key) => (
            <Grid item xs={4} key={key}>
              <Button
                variant="outlined"
                fullWidth
                sx={{ height: "60px" }}
                onClick={() => handleButtonClick(key)}
              >
                {key}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
    <Grid
  sx={{
    backgroundColor: "#333",
    padding: 2,
    display: "flex",
    justifyContent: "space-between", // Keeps the "Finish" button on the right
    alignItems: "center",
  }}
>
  {/* Left aligned icon and button */}
  <Grid
    sx={{
      display: "flex",
      alignItems: "center",
    }}
  >
    <WSIcons.GTranslateIcon sx={{ marginRight: 2 }} />
    <Button
      variant="outlined"
      sx={{
        color: "white",
        borderColor: "green",
        "&:hover": {
          backgroundColor: "#2e7d32",
        },
      }}
      onClick={()=>handleClick('/guestsearch')}
    >
      Guest Search
    </Button>
  </Grid>

  {/* Right aligned Finish button */}
  <Button
    variant="contained"
    sx={{
      backgroundColor: "green",
      "&:hover": {
        backgroundColor: "#388e3c",
      },
    }}
  >
    Finish
  </Button>
</Grid>

    </Grid>

  );
});
